import React, { useState, useEffect } from "react";
import { Icon, Input, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { truncate } from "lodash";
import isSearchStringValid from "helpers/is-search-string-valid";

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    paddingLeft: theme.spacing(2),
  },
  input: {
    "&::-ms-clear": {
      display: "none",
    },
  },
}));

const SearchInput = ({
  value,
  onChange,
  onSearch,
  searchPlaceholder,
  renderExtraActions,
  classes,
  minInputLength = 3,
  maxInputLength = 500,
  onClearSearch,
  autoFocus,
}) => {
  const styles = useStyles();
  const [inputValue, setInputValue] = useState(value || "");

  const disabled = !isSearchStringValid(inputValue, minInputLength, maxInputLength);

  useEffect(() => {
    setInputValue(value === null ? "" : value);
  }, [value]);

  const search = newSearchValue => onSearch(newSearchValue);

  const enterPressed = event => {
    const code = event.keyCode || event.which;
    if (code === 13) {
      search(inputValue);
    }
  };

  const inputChanged = event => {
    setInputValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const clearSearch = () => {
    setInputValue("");
    // if onClearSearch function is not pass in use default clear
    if (onClearSearch) {
      onClearSearch();
    } else {
      search(null);
    }
  };

  return (
    <Input
      placeholder={truncate(searchPlaceholder, { length: 40 }) || "Search"}
      disableUnderline
      fullWidth
      value={inputValue}
      inputProps={{ "aria-label": "Search" }}
      onChange={inputChanged}
      onKeyPress={disabled ? () => null : enterPressed}
      classes={{ root: styles.root, input: styles.input, ...classes }}
      autoFocus={autoFocus}
      endAdornment={(
        <>
          {value && (
            <IconButton onClick={clearSearch}>
              <Icon fontSize="small">clear</Icon>
            </IconButton>
          )}
          <IconButton onClick={() => search(inputValue)}>
            <Icon fontSize="small">search</Icon>
          </IconButton>
          {renderExtraActions && renderExtraActions}
        </>
      )}
    />
  );
};

export default SearchInput;
